import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmopFormComponent } from './emop-form/emop-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmopSidebarComponent } from './emop-sidebar/emop-sidebar.component';
import { EmopTableComponent } from './emop-table/emop-table.component';
import { EmopUtilsService } from '../services/emop-utils.service';
import { EmopFormItemComponent } from './emop-form-item/emop-form-item.component';
import { EmopTreeComponent } from './emop-tree/emop-tree.component';
import { EmopMenuComponent } from './emop-menu/emop-menu.component';
import { RouterModule } from "@angular/router";
import { EmopEditorComponent } from './emop-editor/emop-editor.component';
import { EmopTableProComponent } from './emop-table-pro/emop-table-pro.component';
import { EmopFormProComponent } from './emop-form-pro/emop-form-pro.component';
import { EmopItemComponent } from './emop-item/emop-item.component';
import { EmopSidebarPasswordComponent } from './emop-sidebar/components/emop-sidebar-password/emop-sidebar-password.component';
import { EmopApiComponent } from './emop-api/emop-api.component';
import { EmopApiItemComponent } from './emop-api-item/emop-api-item.component';
import { BaseUiModule } from '../modules/base-ui.module';
import { EmopSidebarAboutComponent } from './emop-sidebar/components/emop-sidebar-about/emop-sidebar-about.component';

@NgModule({
  declarations: [
    EmopFormComponent,
    EmopSidebarComponent,
    EmopTableComponent,
    EmopFormItemComponent,
    EmopTreeComponent,
    EmopMenuComponent,
    EmopEditorComponent,
    EmopTableProComponent,
    EmopFormProComponent,
    EmopItemComponent,
    EmopSidebarPasswordComponent,
    EmopApiComponent,
    EmopApiItemComponent,
    EmopSidebarAboutComponent
  ],
  imports: [
    BaseUiModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  providers: [
    EmopUtilsService,
  ],
  exports: [
    EmopFormComponent,
    EmopSidebarComponent,
    EmopFormItemComponent,
    EmopTableComponent,
    EmopTreeComponent,
    EmopMenuComponent,
    EmopEditorComponent,
    EmopTableProComponent,
    EmopFormProComponent,
    EmopItemComponent,
    EmopApiComponent,
    EmopApiItemComponent
  ]
})
export class EmopModule { }
